<template>
  <dd-modal
    title="Original Email"
    desktop-sizing="grow"
    class="cdhevv"
    extend-height
    @handle-close="$emit('canceled')"
  >
    <div class="html-description-wrapper">
      <iframe
        :src="stylizedHtmlDescriptionLink"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        frameborder="0"
        scrolling="auto" 
      />
    </div>
    <!-- FOOTER -->
    <template #footer>
      <span>
        <dd-button type="flat" @click="$emit('canceled')">Close</dd-button>
      </span>
    </template>
  </dd-modal>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'ConversationDetailHtmlEventVersionViewer',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    stylizedHtmlDescriptionLink: {
      type: String,
      required: true,
    },
  },
  emits: ['canceled'],
  data() {
    return {
      isLoading: false,
    }
  },
})
</script>

<style lang="scss">
.cdhevv {
  .html-description-wrapper {
    iframe {
      width: 100%;
      border: solid 1px $silver-two;
      border-radius: 4px;
      height: 60vh;
    }
  }
}
</style>
